<template>
    <!-- LAUNCHER BUTTON -->
    <button class="btn branding-background branding-text chat-toggle" id=""
            :style="[backgroundColorStyles, foregroundColorStyles]"
            v-if="activeScreen === ScreensEnum.chatButton"
            v-on:click="launchChat">
        <i class="glyphicon glyphicon-comment"></i>&nbsp;&nbsp;Chat
    </button>
</template>

<script>
import screenNavMixin from '../mixins/screen-nav';

export default {
    mixins: [screenNavMixin],
    data(){
        return {
            backgroundColorStyles: {
                "background-color": this.$appBranding.backgroundColor
            },
            foregroundColorStyles: {
                "color": this.$appBranding.foregroundColor
            }
        }
    },
    methods: {
        launchChat: function() {
            // If we are in an active chat, then open the
            // chat client, else start a new chat.
            if (this.$appStore.state.activeChat) {
                this.nextScreen(this.ScreensEnum.conversationClient);
            } else {
                this.nextScreen(this.ScreensEnum.startConversation);
            }
        }
    }
};
</script>

<style>
</style>